import { render, staticRenderFns } from "./NormasList.vue?vue&type=template&id=42063b1a&"
import script from "./NormasList.vue?vue&type=script&lang=js&"
export * from "./NormasList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports